import React, { useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import slides from "./leaderSlides.json";
import testimonialCards from "./testimonialCards.json";
import {
  IgniteMainWrapper,
  BannerSection,
  BannerContent,
  BannerTitle,
  TestimonialWrapper,
  HeaderRow,
  SectionTitle,
  SectionSubtitle,
  SortSelect,
  CardsGrid,
  TestimonialCard,
  VideoThumb,
  PlayButton,
  PlayIcon,
  DurationBadge,
  DurationIcon,
  CardBody,
  CardTitle,
  CardSubtitle,
  QuoteCard,
  QuoteIcon,
  QuoteText,
  ProfileRow,
  Avatar,
  ProfileInfo,
  ProfileName,
  ProfileRole,
  ViewAllWrapper,
  ViewAllButton,
  LeadersSection,
  LeadersHeader,
  LeadersTitleBlock,
  LeadersTitle,
  LeadersSubtitle,
  LeadersTrack,
  LeadersNav,
  NavButton,
  NavIcon,
  LeadersCardsRow,
  LeaderCard,
  LeaderImageWrap,
  LeaderImage,
  LeaderContent,
  LeaderQuote,
  LeaderName,
  LeaderDesignation,
  StatsWrapper,
  StatItem,
  StatValue,
  StatLabel,
  PaginationButton,
  PaginationWrapper,
  PageNumber,
  ReadMore,
} from "./testimonialsContent.styles";

function TestimonialsContent() {
  const SLIDE_WIDTH = 484;
  const VISIBLE_SLIDES = 3;
  const MAX_SLIDES = slides.length;

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prev) => {
      const lastIndex = MAX_SLIDES - VISIBLE_SLIDES;
      return prev >= lastIndex ? 0 : prev + 1;
    });
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => {
      const lastIndex = MAX_SLIDES - VISIBLE_SLIDES;
      return prev <= 0 ? lastIndex : prev - 1;
    });
  };

  const ITEMS_PER_PAGE = 3;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(testimonialCards.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedCards = testimonialCards.slice(startIndex, endIndex);
  const [isAnimating, setIsAnimating] = useState(false);
  const goToPage = (page) => {
    if (page === currentPage) return;

    setIsAnimating(true);

    setTimeout(() => {
      setCurrentPage(page);
      setIsAnimating(false);
    }, 200);
  };

  const [expandedId, setExpandedId] = useState(null);
  const toggleExpand = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <>
      <div className="faq-banner-wrap">
        <img
          src={process.env.PUBLIC_URL + "/Assets/Home/Ignite-banner3.png"}
          alt="Ignite banner"
          className="banner-img"
        />
        <div className="dashboard-banner-box">
          <div className="dashboard-banner-content">
            <h1 className="banner-main-head">
              What Our Learners says about IGNITE
            </h1>
            <p className="banner-sub-text"></p>
          </div>
        </div>
      </div>

      <TestimonialWrapper>
        <HeaderRow>
          <div>
            <SectionTitle>What Our Learners says about IGNITE</SectionTitle>
            <SectionSubtitle>
              Learn from the leaders and Experts for fast-paced presentation
              format designed to share ideas quickly and memorably.
            </SectionSubtitle>
          </div>

          <SortSelect>
            <option>Latest</option>
            <option>Oldest</option>
          </SortSelect>
        </HeaderRow>

        <CardsGrid className={isAnimating ? "fadeOut" : "fadeIn"}>
          {paginatedCards.map((item) => (
            <div key={item.id}>
              <TestimonialCard>
                <VideoThumb>
                  <img
                    src={`${process.env.PUBLIC_URL}${item.videoThumb}`}
                    alt="testimonial"
                  />

                  <PlayButton>
                    <PlayIcon
                      src={`${process.env.PUBLIC_URL}/Assets/Testimonials/play-icon.png`}
                      alt="play"
                    />
                  </PlayButton>

                  <DurationBadge>
                    <DurationIcon
                      src={`${process.env.PUBLIC_URL}/Assets/Testimonials/clock-icon.png`}
                      alt="duration"
                    />
                    {item.duration}
                  </DurationBadge>
                </VideoThumb>

                <CardBody>
                  <CardTitle>{item.name}</CardTitle>
                  <CardSubtitle>{item.designation}</CardSubtitle>
                </CardBody>
              </TestimonialCard>

              <QuoteCard>
                <QuoteText
                  sx={
                    expandedId === item.id
                      ? {
                          display: "block",
                          overflow: "visible",
                        }
                      : {
                          display: "-webkit-box",
                          WebkitLineClamp: 5,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }
                  }
                >
                  {item.quote}
                </QuoteText>

                {item.quote.length > 140 && (
                  <ReadMore onClick={() => toggleExpand(item.id)}>
                    {expandedId === item.id ? "Read less" : "Read more"}
                  </ReadMore>
                )}
                <QuoteIcon
                  src={`${process.env.PUBLIC_URL}/Assets/Testimonials/quote-close-icon.png`}
                  alt="quote"
                />

                <ProfileRow>
                  <Avatar />
                  <ProfileInfo>
                    <ProfileName>{item.name}</ProfileName>
                    <ProfileRole>{item.designation}</ProfileRole>
                  </ProfileInfo>
                </ProfileRow>
              </QuoteCard>
            </div>
          ))}
        </CardsGrid>

        <PaginationWrapper>
          <PaginationButton
            disabled={currentPage === 1}
            onClick={() => goToPage(currentPage - 1)}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Assets/Testimonials/arrow-left-icon.png`}
              alt="previous"
            />
          </PaginationButton>

          {[...Array(totalPages)].map((_, index) => {
            const page = index + 1;
            return (
              <PageNumber
                key={page}
                active={currentPage === page}
                onClick={() => goToPage(page)}
              >
                {page}
              </PageNumber>
            );
          })}

          <PaginationButton
            disabled={currentPage === totalPages}
            onClick={() => goToPage(currentPage + 1)}
          >
            <img
              src={`${process.env.PUBLIC_URL}/Assets/Testimonials/arrow-right-icon.png`}
              alt="next"
            />
          </PaginationButton>
        </PaginationWrapper>
      </TestimonialWrapper>

      <LeadersSection>
        <LeadersHeader>
          <LeadersTitleBlock>
            <LeadersTitle>
              What Our Leaders says about IGNITE Courses
            </LeadersTitle>
            <LeadersSubtitle>
              Learn from the leaders and Experts for fast-paced presentation
              format designed to share ideas quickly and memorably.
            </LeadersSubtitle>
          </LeadersTitleBlock>

          <LeadersNav>
            <NavButton onClick={handlePrev}>
              <NavIcon
                src={`${process.env.PUBLIC_URL}/Assets/Testimonials/arrow-left-icon.png`}
                alt="previous"
              />
            </NavButton>

            <NavButton onClick={handleNext}>
              <NavIcon
                src={`${process.env.PUBLIC_URL}/Assets/Testimonials/arrow-right-icon.png`}
                alt="next"
              />
            </NavButton>
          </LeadersNav>
        </LeadersHeader>

        <LeadersCardsRow>
          <LeadersTrack
            style={{
              transform: `translateX(-${currentIndex * SLIDE_WIDTH}px)`,
            }}
          >
            {slides.map((item, index) => {
              const isActive =
                index === currentIndex || index === currentIndex + 1;

              return (
                <LeaderCard
                  key={item.id}
                  className={isActive ? "active" : "inactive"}
                >
                  <LeaderImageWrap>
                    <LeaderImage
                      src={`${process.env.PUBLIC_URL}${item.image}`}
                      alt={item.name}
                    />
                  </LeaderImageWrap>

                  <LeaderContent>
                    <LeaderQuote>{item.quote}</LeaderQuote>
                    <LeaderName>{item.name}</LeaderName>
                    <LeaderDesignation>{item.designation}</LeaderDesignation>
                  </LeaderContent>
                </LeaderCard>
              );
            })}
          </LeadersTrack>
        </LeadersCardsRow>
      </LeadersSection>

      <StatsWrapper>
        <StatItem>
          <StatValue>4.9/5</StatValue>
          <StatLabel>Average Rating</StatLabel>
        </StatItem>

        <StatItem>
          <StatValue>10K+</StatValue>
          <StatLabel>Happy Learners</StatLabel>
        </StatItem>

        <StatItem>
          <StatValue>98%</StatValue>
          <StatLabel>Would Recommended</StatLabel>
        </StatItem>

        <StatItem>
          <StatValue>500+</StatValue>
          <StatLabel>5 star Reviews</StatLabel>
        </StatItem>
      </StatsWrapper>
    </>
  );
}

export default TestimonialsContent;
